import ReactDOM from "react-dom/client";
import App from "./app/App";
import "@app/styles/global.css";
import { StoreProvider } from "@app/providers/StoreProvider";

// Создаем элемент для модальных окон
const modalRoot = document.createElement("div");
modalRoot.id = "modal";
document.body.appendChild(modalRoot);

ReactDOM.createRoot(document.getElementById("root")!).render(
  <StoreProvider>
    <App />
  </StoreProvider>
);
